module.exports = "/assets/data/915c927d2e24013eb181dd6a57043cff-BD6.data.json";